const KEY = "dh_buyers";

function readBuyers() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

function writeBuyers(buyers) {
  localStorage.setItem(KEY, JSON.stringify(buyers));
}

export function peekBuyers() {
  return readBuyers();
}

export function createBuyer(data) {
  /* POST /buyers */
  const buyers = readBuyers();
  const buyer = {
    id: data.id || crypto.randomUUID(),
    name: data.name || "",
    email: data.email || "",
    phone: data.phone || "",
    password: data.password,
    agentId: data.agentId || "",
    preferences: data.preferences || {
      location: {},
      homeType: {},
      lot: {},
      exterior: {},
      interior: {},
      lifestyle: {},
      accessibility: {},
      notes: {
        dealBreakers: "",
        mustHaves: "",
        householdNeeds: "",
        priorities: "",
        specialNotes: "",
        attachments: [],
      },
      tipsAcknowledged: false,
      transactionChecklist: {},
    },
    status: data.status || "active",
    createdAt: new Date().toISOString(),
  };
  buyers.push(buyer);
  writeBuyers(buyers);
  return Promise.resolve(buyer);
}

export function getBuyer(id) {
  /* GET /buyers/:id */
  const buyer = readBuyers().find((item) => item.id === id) || null;
  return Promise.resolve(buyer);
}

export function updateBuyer(id, data) {
  /* PUT /buyers/:id */
  const buyers = readBuyers();
  const index = buyers.findIndex((item) => item.id === id);
  if (index === -1) return Promise.reject(new Error("Buyer not found"));
  buyers[index] = { ...buyers[index], ...data, id };
  writeBuyers(buyers);
  return Promise.resolve(buyers[index]);
}

export function listBuyersByAgent(agentId) {
  /* GET /agents/:id/buyers */
  const buyers = readBuyers().filter((item) => item.agentId === agentId);
  return Promise.resolve(buyers);
}

export function listBuyersForSession(session, listAgentId, excludeAgentId) {
  if (listAgentId) return listBuyersByAgent(listAgentId);
  if (session?.role === "broker" || session?.role === "admin") {
    return listBuyers().then((rows) =>
      excludeAgentId ? rows.filter((item) => item.agentId !== excludeAgentId) : rows
    );
  }
  return listBuyersByAgent(session?.userId || "");
}

export function listBuyers() {
  return Promise.resolve(readBuyers());
}
